export default __webpack_public_path__ + "static/media/Group 1674.46455567.png";